// Current Lodge action types

const currentLodgeActionTypes = {
  UPDATE_CURRENT_LODGE: 'UPDATE_CURRENT_LODGE'
};

export default currentLodgeActionTypes;
